import { useEffect, useId, useRef, useState } from "react";

// O gatilho, o menu e o teclado que o Select e o MultiSelect compartilham.
export function useSelectMenu(optionCount) {
  const baseId = useId();
  const ids = {
    labelId: `${baseId}-label`,
    valueId: `${baseId}-value`,
    listId: `${baseId}-list`,
  };

  const shellRef = useRef(null);
  const triggerRef = useRef(null);
  const optionRefs = useRef([]);

  const [open, setOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [insideDialog, setInsideDialog] = useState(false);

  useEffect(() => {
    if (open) optionRefs.current[activeIndex]?.focus();
  }, [open, activeIndex]);

  // No click, não no mousedown: fechar antes do mouseup reflui o que está embaixo
  // e o clique morre entre os dois eventos.
  useEffect(() => {
    if (!open) return undefined;

    const closeOnOutsideClick = (event) => {
      if (!shellRef.current.contains(event.target)) setOpen(false);
    };

    document.addEventListener("click", closeOnOutsideClick);
    return () => document.removeEventListener("click", closeOnOutsideClick);
  }, [open]);

  const openAt = (index) => {
    setInsideDialog(!!shellRef.current.closest('[role="dialog"]'));
    setActiveIndex(Math.max(index, 0));
    setOpen(true);
  };

  const closeAndRestoreFocus = () => {
    setOpen(false);
    triggerRef.current.focus();
  };

  const handleTriggerKeyDown = (event, index) => {
    if (event.key !== "ArrowDown" && event.key !== "ArrowUp") return;
    event.preventDefault();
    openAt(index);
  };

  const handleOptionKeyDown = (event, index, choose) => {
    const lastIndex = optionCount - 1;

    if (event.key === "ArrowDown") {
      event.preventDefault();
      setActiveIndex(Math.min(index + 1, lastIndex));
    } else if (event.key === "ArrowUp") {
      event.preventDefault();
      setActiveIndex(Math.max(index - 1, 0));
    } else if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      choose(index);
    } else if (event.key === "Escape") {
      // Dentro de um modal, o Esc que fecha o menu não pode fechar o diálogo.
      event.stopPropagation();
      closeAndRestoreFocus();
    } else if (event.key === "Tab") {
      setOpen(false);
    }
  };

  return {
    ids,
    shellRef,
    triggerRef,
    optionRefs,
    open,
    setOpen,
    openAt,
    insideDialog,
    closeAndRestoreFocus,
    handleTriggerKeyDown,
    handleOptionKeyDown,
  };
}
